import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { DOCTOR } from "@/lib/data";

const links = [
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#clinics", label: "Clinics" },
  { href: "#articles", label: "Articles" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "glass-nav" : "bg-transparent"}`}
    >
      <nav className="container-page flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="font-serif text-2xl md:text-[26px] tracking-tight text-forest leading-none">
          {DOCTOR.name}
          <span className="block text-[10px] tracking-[0.3em] uppercase text-sage font-sans font-semibold mt-1">Gynaecologist & Obstetrician</span>
        </Link>

        <ul className="hidden lg:flex items-center gap-10 text-[15px] text-forest/80">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-${l.label.toLowerCase()}`}
                href={l.href}
                className="relative hover:text-forest transition-colors after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-terracotta hover:after:w-full after:transition-all after:duration-300"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <a data-testid="nav-call" href={`tel:${DOCTOR.phones[0].replace(/\s/g, "")}`} className="btn-outline h-11 px-5 text-sm">
            <Phone className="w-4 h-4" strokeWidth={1.5} /> Call Clinic
          </a>
          <a data-testid="nav-book" href="#book" className="btn-primary h-11 px-5 text-sm">Book Consultation</a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden text-forest"
          onClick={() => setOpen(!open)}
        >
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden glass-nav border-t border-sand/60">
          <ul className="container-page py-6 flex flex-col gap-5 text-forest/90">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={() => setOpen(false)} className="block py-2 text-lg">{l.label}</a>
              </li>
            ))}
            <li className="pt-2 flex gap-3">
              <a href={`tel:${DOCTOR.phones[0].replace(/\s/g, "")}`} className="btn-outline flex-1">Call</a>
              <a href="#book" onClick={() => setOpen(false)} className="btn-primary flex-1">Book</a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
